import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import API from '../services/api';

function Checkout() {
    const navigate = useNavigate();
    const location = useLocation();
    const plan = location.state?.plan;

    const [loading, setLoading] = useState(false);
    const [userInfo] = useState({
        name: localStorage.getItem('userName') || 'User',
        email: localStorage.getItem('userEmail') || ''
    });

    // ✅ NEW: Billing Info State
    const [billingInfo, setBillingInfo] = useState({
        phone: '',
        address: '',
        city: '',
        state: '',
        pincode: '',
        country: 'India'
    });

    const [billingErrors, setBillingErrors] = useState({});

    // ✅ KYC State
    const [kycInfo, setKycInfo] = useState({
        accountType: '',
        companyName: '',
        companyDescription: '',
        panNumber: '',
        gstNumber: ''
    });
    const [kycErrors, setKycErrors] = useState({});
    const [isFirstPayment, setIsFirstPayment] = useState(false);

    useEffect(() => {
        if (!plan) {
            navigate('/pricing');
        }
    }, [plan, navigate]);
    useEffect(() => {
        if (!plan) {
            navigate('/pricing');
        }
    }, [plan, navigate]);

    // ✅ ADD THIS BLOCK YAHAN
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    // ✅ Check if first payment
    useEffect(() => {
        const checkKyc = async () => {
            try {
                const res = await API.get('/organization');
                const org = res.data.data;
                setIsFirstPayment(!org.kyc_submitted);
            } catch (e) {
                setIsFirstPayment(false);
            }
        };
        checkKyc();
    }, []);
    // ✅ NEW: Validate billing form before payment
   // ✅ Updated Validation (Indian Mobile + Numeric PIN)
    const validateBilling = () => {
        const errors = {};
        
        // Indian Mobile: 10 digits starting with 6, 7, 8, or 9
        const mobileRegex = /^[6-9]\d{9}$/;
        // PIN Code: Exact 6 digits, only numbers
        const pincodeRegex = /^\d{6}$/;

        // Mobile Validation
        if (!billingInfo.phone.trim()) {
            errors.phone = 'Phone number is required';
        } else if (!mobileRegex.test(billingInfo.phone.trim())) {
            errors.phone = 'Please enter a valid 10-digit Indian mobile number';
        }

        if (!billingInfo.address.trim()) errors.address = 'Address is required';
        if (!billingInfo.city.trim()) errors.city = 'City is required';
        if (!billingInfo.state.trim()) errors.state = 'State is required';

        // PIN Code Validation
        if (!billingInfo.pincode.trim()) {
            errors.pincode = 'PIN Code is required';
        } else if (!pincodeRegex.test(billingInfo.pincode.trim())) {
            errors.pincode = 'Please enter a valid 6-digit PIN code';
        }

        setBillingErrors(errors);

        if (isFirstPayment) {
            const kErr = {};
            if (!kycInfo.accountType) kErr.accountType = 'Please select account type';
            if (kycInfo.accountType === 'company') {
                if (!kycInfo.companyName.trim()) kErr.companyName = 'Company name is required';
                if (!kycInfo.panNumber.trim()) kErr.panNumber = 'PAN number is required';
                if (!kycInfo.gstNumber.trim()) kErr.gstNumber = 'GST number is required';
            }
            setKycErrors(kErr);
            if (Object.keys(kErr).length > 0) return false;
        }

        return Object.keys(errors).length === 0;
    };

    const showSuccessModal = (planName) => {
        const modal = document.createElement('div');
        modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.65);backdrop-filter:blur(8px);display:flex;align-items:center;justify-content:center;z-index:99999;padding:20px;';
        modal.setAttribute('data-modal', 'success');

        const closeAndRedirect = () => {
            if (document.body.contains(modal)) {
                document.body.removeChild(modal);
            }
            window.location.href = '/dashboard';
        };

        modal.innerHTML = `
        <div style="max-width:500px;width:100%;border-radius:24px;overflow:hidden;box-shadow:0 30px 60px rgba(7,94,84,0.4);border:1.5px solid rgba(37,211,102,0.25);">
            
            <!-- Header -->
            <div style="background:linear-gradient(135deg,#075E54,#128C7E,#25D366);padding:28px 28px 22px;text-align:center;position:relative;overflow:hidden;">
                <div style="position:absolute;top:-40px;right:-40px;width:140px;height:140px;background:rgba(255,255,255,0.07);border-radius:50%;pointer-events:none;"></div>
                
                <!-- Close Button -->
                <button id="ct-close-btn"
                    style="position:absolute;top:12px;right:12px;width:30px;height:30px;background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.3);border-radius:8px;color:white;font-size:15px;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:10;"
                >✕</button>
                
                <!-- Logo -->
                <div style="margin:0 auto 12px;display:flex;flex-direction:column;align-items:center;gap:4px;">
                    <img src="/logo 1.png" alt="ChatTech24" style="height:48px;width:auto;object-fit:contain;" />
                    <span style="color:white;font-family:'Sora',sans-serif;font-size:13px;font-weight:700;opacity:0.9;letter-spacing:0.5px;">ChatTech24</span>
                </div>
                
                <h2 style="margin:0 0 6px;color:white;font-family:'Sora',sans-serif;font-size:26px;font-weight:800;">Payment Successful! 🎉</h2>
                <p style="margin:0;color:rgba(255,255,255,0.9);font-size:13px;">Your subscription is now active</p>
            </div>

            <!-- Body -->
            <div style="padding:24px;background:white;">
                
                <!-- Plan Box -->
                <div style="background:linear-gradient(135deg,#f0fdf4,#dcfce7);border:1.5px solid rgba(37,211,102,0.3);border-radius:14px;padding:14px 18px;margin-bottom:16px;text-align:center;">
                    <div style="font-size:10px;font-weight:800;color:#166534;letter-spacing:1px;margin-bottom:4px;">YOUR ACTIVE PLAN</div>
                    <div style="font-family:'Sora',sans-serif;font-size:20px;color:#065f46;font-weight:800;">${planName}</div>
                </div>

                <!-- Thank You Message -->
                <div style="text-align:center;margin-bottom:16px;">
                    <p style="font-size:14px;color:#1e293b;font-weight:600;margin:0 0 4px;">Thank you for choosing ChatTech24! 🙏</p>
                    <p style="font-size:12px;color:#64748b;line-height:1.6;margin:0;">Your WhatsApp automation journey starts now. All features are unlocked and ready to use.</p>
                </div>

                <!-- Features Row -->
                <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-bottom:16px;">
                    <div style="text-align:center;padding:10px 6px;background:#f0fdf9;border-radius:10px;border:1px solid rgba(37,211,102,0.2);">
                        <div style="font-size:20px;margin-bottom:3px;">🤖</div>
                        <div style="font-size:10px;font-weight:600;color:#065f46;">AI Agent</div>
                    </div>
                    <div style="text-align:center;padding:10px 6px;background:#f0fdf9;border-radius:10px;border:1px solid rgba(37,211,102,0.2);">
                        <div style="font-size:20px;margin-bottom:3px;">📊</div>
                        <div style="font-size:10px;font-weight:600;color:#065f46;">Flows</div>
                    </div>
                    <div style="text-align:center;padding:10px 6px;background:#f0fdf9;border-radius:10px;border:1px solid rgba(37,211,102,0.2);">
                        <div style="font-size:20px;margin-bottom:3px;">💬</div>
                        <div style="font-size:10px;font-weight:600;color:#065f46;">WhatsApp</div>
                    </div>
                </div>

                <!-- Timer Bar -->
                <div style="margin-bottom:14px;">
                    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:5px;">
                        <span style="font-size:11px;color:#94a3b8;">Redirecting to Dashboard...</span>
                        <span id="ct-countdown" style="font-size:11px;font-weight:700;color:#128C7E;">5s</span>
                    </div>
                    <div style="height:4px;background:#e2e8f0;border-radius:4px;overflow:hidden;">
                        <div id="ct-timer-bar" style="height:100%;background:linear-gradient(90deg,#25D366,#128C7E);border-radius:4px;width:100%;transition:width 1s linear;"></div>
                    </div>
                </div>

                <!-- Go to Dashboard Button -->
                <button id="ct-dashboard-btn"
                    style="width:100%;padding:13px;background:linear-gradient(135deg,#25D366,#128C7E);color:white;border:none;border-radius:12px;font-size:14px;font-weight:800;cursor:pointer;font-family:'Sora',sans-serif;box-shadow:0 4px 16px rgba(37,211,102,0.35);"
                >🚀 Go to Dashboard</button>
            </div>
        </div>
    `;

        document.body.appendChild(modal);

        // Button event listeners
        modal.querySelector('#ct-close-btn').addEventListener('click', closeAndRedirect);
        modal.querySelector('#ct-dashboard-btn').addEventListener('click', closeAndRedirect);

        // Countdown timer
        let seconds = 20;
        const countdownEl = modal.querySelector('#ct-countdown');
        const timerBar = modal.querySelector('#ct-timer-bar');

        const interval = setInterval(() => {
            seconds--;

            if (countdownEl) {
                countdownEl.textContent = seconds + 's';
            }

            if (timerBar) {
                timerBar.style.width = (seconds / 20 * 100) + '%';
            }

            if (seconds <= 0) {
                clearInterval(interval);
                closeAndRedirect();
            }
        }, 1000);
    };

    const handlePayment = async () => {
        // ✅ NEW: Validate billing info first
        if (!validateBilling()) {
            toast.error('Please fill in all required billing details');
            return;
        }

        setLoading(true);
        const toastId = toast.loading('Creating order...');

        try {
            const orderRes = await API.post('/subscriptions/create-order', {
                planId: plan.id
            });

            const { orderId, amount, currency, testing } = orderRes.data.data;

            toast.dismiss(toastId);

            // TESTING MODE - Skip Razorpay modal
            if (testing || orderRes.data.testing) {
                const verifyToast = toast.loading('🧪 TEST: Processing dummy payment...');

                await new Promise(resolve => setTimeout(resolve, 1500));

                try {
                    await API.post('/subscriptions/verify-payment', {
                        orderId: orderId,
                        paymentId: `test_pay_${Date.now()}`,
                        signature: 'test_signature',
                        planId: plan.id,
                        billingInfo: billingInfo  // ✅ NEW: Send billing info
                    });

                    localStorage.setItem('subscriptionPlan', `${plan.name} — ${plan.subtitle || ''}`);

                    localStorage.setItem('subscriptionStatus', 'active');
                    localStorage.setItem('subscriptionPlanId', plan.id); // ✅ YEH ADD KARO


                   // ✅ KYC save karo first payment pe
                    if (isFirstPayment && kycInfo.accountType) {
                        try {
                            await API.post('/organization/kyc', kycInfo);
                        } catch (kycErr) {
                            console.error('KYC save error:', kycErr);
                        }
                    }

                    toast.dismiss(verifyToast);
                    localStorage.setItem('subscription_updated', Date.now().toString());
                    showSuccessModal(plan.name);
                } catch (err) {
                    toast.error('Payment verification failed!', { id: verifyToast });
                }

                setLoading(false);
                return;
            }

            // PRODUCTION MODE - Real Razorpay
            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY_ID,
                amount: amount,
                currency: currency,
                name: 'ChatTech24',
                description: `${plan.name} Plan Subscription`,
                order_id: orderId,
                handler: async function (response) {
                    const verifyToast = toast.loading('Verifying payment...');
                    try {
                        await API.post('/subscriptions/verify-payment', {
                            orderId: response.razorpay_order_id,
                            paymentId: response.razorpay_payment_id,
                            signature: response.razorpay_signature,
                            planId: plan.id,
                            billingInfo: billingInfo  // ✅ NEW: Send billing info
                        });

                        localStorage.setItem('subscriptionPlan', `${plan.name} — ${plan.subtitle || ''}`);

                        localStorage.setItem('subscriptionStatus', 'active');
                        localStorage.setItem('subscriptionPlanId', plan.id); // ✅ YEH ADD KARO


                        // ✅ KYC save karo first payment pe
                        if (isFirstPayment && kycInfo.accountType) {
                            try {
                                await API.post('/organization/kyc', kycInfo);
                            } catch (kycErr) {
                                console.error('KYC save error:', kycErr);
                            }
                        }

                        toast.dismiss(verifyToast);
                        localStorage.setItem('subscription_updated', Date.now().toString());
                        showSuccessModal(plan.name);
                    } catch (err) {
                        toast.error('Payment verification failed!', { id: verifyToast });
                    }
                },
                prefill: {
                    name: userInfo.name,
                    email: userInfo.email,
                    contact: billingInfo.phone  // ✅ NEW: Prefill phone in Razorpay
                },
                theme: { color: '#667eea' }
            };

            if (window.Razorpay) {
                const rzp = new window.Razorpay(options);
                rzp.open();
            } else {
                toast.error('Razorpay not loaded. Please refresh.');
            }

        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to create order', { id: toastId });
        } finally {
            setLoading(false);
        }
    };

    if (!plan) return null;

    return (
        <div className="checkout-wrapper">
            <nav className="landing-nav">
                <button onClick={() => navigate('/pricing')} className="landing-btn-outline">← Back</button>

                {/* Logo + Title center mein */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <img
                        src="/logo 1.png"
                        alt="ChatTech24"
                        style={{ height: '32px', width: 'auto', objectFit: 'contain' }}
                        onError={(e) => e.target.style.display = 'none'}
                    />
                    <span className="checkout-nav-title">ChatTech24 — Checkout</span>
                </div>

                {/* Right side — SSL badge */}
                <div style={{
                    display: 'flex', alignItems: 'center', gap: '6px',
                    background: 'rgba(255,255,255,0.12)',
                    padding: '6px 12px', borderRadius: '8px',
                    border: '1px solid rgba(255,255,255,0.2)'
                }}>
                    <span style={{ fontSize: '14px' }}>🔒</span>
                    <span style={{ color: 'white', fontSize: '12px', fontWeight: '600' }}>SSL Secured</span>
                </div>
            </nav>

            <div className="checkout-content">
                <div className="checkout-grid">
                    {/* LEFT: Order Summary */}
                    <div className="checkout-summary-card">
                        <div className="checkout-summary-header">
                            <h2 className="checkout-summary-title">Order Summary</h2>
                            <p className="checkout-summary-subtitle">Review your plan details</p>
                        </div>
                        <div className="checkout-summary-body">
                            <div className="checkout-plan-box">
                                <h3 className="checkout-plan-name">{plan.name}</h3>
                                <div className="checkout-plan-price">
                                    ₹{parseInt(plan.price).toLocaleString()}
                                    <span className="checkout-plan-period">
                                        /{plan.billing_cycle === 'yearly' ? 'year' : 'month'}
                                    </span>
                                </div>
                            </div>
                            <p className="checkout-features-label">INCLUDED FEATURES:</p>
                            {plan.features.map((feature, i) => (
                                <div key={i} className="checkout-feature-item">
                                    <span className="checkout-feature-check">✓</span>
                                    <span className="checkout-feature-text">{feature}</span>
                                </div>
                            ))}
                            <div className="checkout-secure-badge">
                                <div className="checkout-secure-title">✅ Secure Payment via Razorpay</div>
                                <div className="checkout-secure-subtitle">256-bit SSL encrypted</div>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT: Payment + Billing Info */}
                    <div className="checkout-payment-card">
                        <h2 className="checkout-payment-title">💳 Payment Details</h2>

                        {/* Account Info (Read-only) */}
                        <div className="checkout-user-info">
                            <div className="checkout-field-group">
                                <label className="checkout-field-label">NAME</label>
                                <div className="checkout-field-value">{userInfo.name}</div>
                            </div>
                            <div className="checkout-field-group">
                                <label className="checkout-field-label">EMAIL</label>
                                <div className="checkout-field-value">{userInfo.email}</div>
                            </div>
                        </div>

                        {/* ✅ NEW: Section 1 - Personal Information */}
                        {/* ✅ KYC Section — Only for first payment */}
                        {isFirstPayment && (
                            <div className="checkout-billing-section">
                                <div className="checkout-billing-section-header">
                                    <span className="checkout-billing-section-number">1</span>
                                    <h3 className="checkout-billing-section-title">Account Type</h3>
                                </div>

                                <div className="checkout-billing-field">
                                    <label className="checkout-billing-label">
                                        Are you subscribing as? <span className="checkout-billing-required">*</span>
                                    </label>
                                    <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
                                        {['individual', 'company'].map(type => (
                                            <div
                                                key={type}
                                                onClick={() => setKycInfo({ ...kycInfo, accountType: type })}
                                                style={{
                                                    flex: 1, padding: '14px', borderRadius: '10px',
                                                    border: `2px solid ${kycInfo.accountType === type ? '#667eea' : '#e2e8f0'}`,
                                                    background: kycInfo.accountType === type ? '#eff6ff' : 'white',
                                                    cursor: 'pointer', textAlign: 'center', transition: 'all 0.2s'
                                                }}
                                            >
                                                <div style={{ fontSize: '24px', marginBottom: '6px' }}>
                                                    {type === 'individual' ? '👤' : '🏢'}
                                                </div>
                                                <div style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', textTransform: 'capitalize' }}>
                                                    {type}
                                                </div>
                                                <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px' }}>
                                                    {type === 'individual' ? 'Personal use' : 'Business use'}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {kycErrors.accountType && <span className="checkout-billing-error">{kycErrors.accountType}</span>}
                                </div>

                                {kycInfo.accountType === 'company' && (
                                    <>
                                        <div className="checkout-billing-field">
                                            <label className="checkout-billing-label">
                                                Company Name <span className="checkout-billing-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                value={kycInfo.companyName}
                                                onChange={e => setKycInfo({ ...kycInfo, companyName: e.target.value })}
                                                className={`checkout-billing-input ${kycErrors.companyName ? 'checkout-billing-input-error' : ''}`}
                                                placeholder="Vedvika Technologies Pvt Ltd"
                                            />
                                            {kycErrors.companyName && <span className="checkout-billing-error">{kycErrors.companyName}</span>}
                                        </div>

                                        <div className="checkout-billing-field">
                                            <label className="checkout-billing-label">Brief Description</label>
                                            <textarea
                                                value={kycInfo.companyDescription}
                                                onChange={e => setKycInfo({ ...kycInfo, companyDescription: e.target.value })}
                                                className="checkout-billing-input"
                                                placeholder="Brief description about your company..."
                                                rows={2}
                                                style={{ resize: 'vertical' }}
                                            />
                                        </div>

                                        <div className="checkout-billing-row">
                                            <div className="checkout-billing-field">
                                                <label className="checkout-billing-label">
                                                    PAN Number <span className="checkout-billing-required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={kycInfo.panNumber}
                                                    onChange={e => setKycInfo({ ...kycInfo, panNumber: e.target.value.toUpperCase() })}
                                                    className={`checkout-billing-input ${kycErrors.panNumber ? 'checkout-billing-input-error' : ''}`}
                                                    placeholder="ABCDE1234F"
                                                    maxLength={10}
                                                />
                                                {kycErrors.panNumber && <span className="checkout-billing-error">{kycErrors.panNumber}</span>}
                                            </div>

                                            <div className="checkout-billing-field">
                                                <label className="checkout-billing-label">
                                                    GST Number <span className="checkout-billing-required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={kycInfo.gstNumber}
                                                    onChange={e => setKycInfo({ ...kycInfo, gstNumber: e.target.value.toUpperCase() })}
                                                    className={`checkout-billing-input ${kycErrors.gstNumber ? 'checkout-billing-input-error' : ''}`}
                                                    placeholder="27ABCDE1234F1Z5"
                                                    maxLength={15}
                                                />
                                                {kycErrors.gstNumber && <span className="checkout-billing-error">{kycErrors.gstNumber}</span>}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        )}

                        {/* ✅ NEW: Section 2 - Billing Address */}
                        <div className="checkout-billing-section">
                            <div className="checkout-billing-section-header">
                                <span className="checkout-billing-section-number">2</span>
                                <h3 className="checkout-billing-section-title">Billing Address</h3>
                            </div>

                            <div className="checkout-billing-field">
    <label className="checkout-billing-label">
        Phone Number <span className="checkout-billing-required">*</span>
    </label>
    <input
        type="tel"
        value={billingInfo.phone}
        onChange={(e) => {
            const val = e.target.value.replace(/\D/g, ''); // Non-numeric filter
            setBillingInfo({ ...billingInfo, phone: val });
        }}
        className={`checkout-billing-input ${billingErrors.phone ? 'checkout-billing-input-error' : ''}`}
        placeholder="9876543210"
        maxLength={10}
    />
    {billingErrors.phone && <span className="checkout-billing-error">{billingErrors.phone}</span>}
</div>

                            <div className="checkout-billing-field">
                                <label className="checkout-billing-label">
                                    Street Address <span className="checkout-billing-required">*</span>
                                </label>
                                <input
                                    type="text"
                                    value={billingInfo.address}
                                    onChange={(e) => setBillingInfo({ ...billingInfo, address: e.target.value })}
                                    className={`checkout-billing-input ${billingErrors.address ? 'checkout-billing-input-error' : ''}`}
                                    placeholder="123, MG Road, Sector 5"
                                />
                                {billingErrors.address && <span className="checkout-billing-error">{billingErrors.address}</span>}
                            </div>

                            <div className="checkout-billing-row">
                                <div className="checkout-billing-field">
                                    <label className="checkout-billing-label">
                                        City <span className="checkout-billing-required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={billingInfo.city}
                                        onChange={(e) => setBillingInfo({ ...billingInfo, city: e.target.value })}
                                        className={`checkout-billing-input ${billingErrors.city ? 'checkout-billing-input-error' : ''}`}
                                        placeholder="Delhi"
                                    />
                                    {billingErrors.city && <span className="checkout-billing-error">{billingErrors.city}</span>}
                                </div>

                                <div className="checkout-billing-field">
                                    <label className="checkout-billing-label">
                                        State <span className="checkout-billing-required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={billingInfo.state}
                                        onChange={(e) => setBillingInfo({ ...billingInfo, state: e.target.value })}
                                        className={`checkout-billing-input ${billingErrors.state ? 'checkout-billing-input-error' : ''}`}
                                        placeholder="Delhi"
                                    />
                                    {billingErrors.state && <span className="checkout-billing-error">{billingErrors.state}</span>}
                                </div>
                            </div>

                            <div className="checkout-billing-row">
                               <div className="checkout-billing-field">
                                    <label className="checkout-billing-label">
                                        PIN Code <span className="checkout-billing-required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={billingInfo.pincode}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/\D/g, ''); // Non-numeric filter
                                            setBillingInfo({ ...billingInfo, pincode: val });
                                        }}
                                        className={`checkout-billing-input ${billingErrors.pincode ? 'checkout-billing-input-error' : ''}`}
                                        placeholder="110001"
                                        maxLength={6}
                                    />
                                    {billingErrors.pincode && <span className="checkout-billing-error">{billingErrors.pincode}</span>}
                                </div>

                                <div className="checkout-billing-field">
                                    <label className="checkout-billing-label">Country</label>
                                    <select
                                        value={billingInfo.country}
                                        onChange={(e) => setBillingInfo({ ...billingInfo, country: e.target.value })}
                                        className="checkout-billing-input checkout-billing-select"
                                    >
                                        <option value="India">🇮🇳 India</option>
                                        <option value="USA">🇺🇸 USA</option>
                                        <option value="UK">🇬🇧 UK</option>
                                        <option value="UAE">🇦🇪 UAE</option>
                                        <option value="Canada">🇨🇦 Canada</option>
                                        <option value="Australia">🇦🇺 Australia</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Price Summary */}
                        <div className="checkout-price-summary">
                            <div className="checkout-price-row">
                                <span className="checkout-price-label">Plan</span>
                                <span className="checkout-price-value">{plan.name}</span>
                            </div>
                            <div className="checkout-price-row">
                                <span className="checkout-price-label">Billing</span>
                                <span className="checkout-price-value">
                                    {plan.billing_cycle === 'yearly' ? 'Annual' : 'Monthly'}
                                </span>
                            </div>
                            {plan.whatsapp_already_configured && plan.whatsapp_setup_cost > 0 && (
                                <>
                                    <div className="checkout-price-row">
                                        <span className="checkout-price-label">Base Price</span>
                                        <span className="checkout-price-value">₹{parseInt(plan.original_price).toLocaleString()}</span>
                                    </div>
                                    <div className="checkout-price-row" style={{ color: '#16a34a' }}>
                                        <span className="checkout-price-label">✅ WhatsApp Setup (Done)</span>
                                        <span className="checkout-price-value">- ₹{parseInt(plan.whatsapp_setup_cost).toLocaleString()}</span>
                                    </div>
                                </>
                            )}
                            <div className="checkout-price-row checkout-price-total">
                                <span className="checkout-total-label">Total</span>
                                <span className="checkout-total-amount">₹{parseInt(plan.price).toLocaleString()}</span>
                            </div>
                        </div>

                        <button
                            onClick={handlePayment}
                            disabled={loading}
                            className={`checkout-pay-btn ${loading ? 'checkout-pay-btn-disabled' : 'checkout-pay-btn-active'}`}
                        >
                            {loading ? '⏳ Processing...' : `🔒 Pay ₹${parseInt(plan.price).toLocaleString()}`}
                        </button>
                        <p className="checkout-terms-text">
    By clicking Pay, you agree to our{' '}
    <Link 
        to="/terms-and-conditions" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{ color: '#128C7E', fontWeight: '600', textDecoration: 'underline' }}
    >
        Terms of Service
    </Link>
</p>
                    </div>
                </div>
            </div>
            {/* <script src="https://checkout.razorpay.com/v1/checkout.js"></script> */}
        </div>
    );
}

export default Checkout;    